import IconPlus from "@/app/(site)/_components/Atoms/Icons/IconPlus"
import { clsx } from "@/src/utils/clsx"

export default function AccordionToggleIcon({
    isOpen,
    className
}: {
    isOpen: boolean
    className?: string
}) {
    return (
        <div className={clsx("transition-transform duration-300 ease-in-out", className)}>
            <IconPlus
                className={clsx(
                    "h-20 w-20 transition-transform duration-300 ease-in-out",
                    isOpen && "rotate-45"
                )}
            />
        </div>
    )
}
